import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Observable } from 'rxjs';
import { InfoWindowDataModel } from '../models/info-window-data.model';

@Injectable({ providedIn: 'root' })
export class InfoWindowDataService {
    constructor(private apiService: ApiService) {}

    public getInfoWindowData(): Observable<InfoWindowDataModel> {
        const uri: string = 'api/info-window';
        return this.apiService.getWithoutErrorHandling<InfoWindowDataModel>(uri);
    }

    public updateInfoWindowData(infoWindowDataModel: InfoWindowDataModel): Observable<InfoWindowDataModel> {
        const uri: string = 'api/info-window';
        return this.apiService.postWithoutErrorHandling(uri, infoWindowDataModel);
    }
}
